(function () {
    'use strict';
    a3_cabin_reports.factory('LeaveRequestFactory', LeaveRequestFactory);

    /**
     * @memberof CabinReports
     * @ngdoc factory
     * @name LeaveRequestFactory
     * @description 
     *    Get Leave Request Configuration Data and submit new Leave Request
     * @ngInject
     */
    function LeaveRequestFactory(GenericService, $http, $q, apiUrl) {

       
        var service = {
            getConfigurationDetails : getConfigurationDetails,
            saveLeaveRequestInformation : saveLeaveRequestInformation,
            getLeaveRequestInformation : getLeaveRequestInformation,
            saveLeaveRequest : saveLeaveRequest,
            getRequestedSlots : getRequestedSlots
        };
        
        /**
        * Initialize the LeaveRequestInformation
        * @memberof LeaveRequestFactory
        */
        function LeaveRequestInformation(){
            
        }
        
        var objType = 'LeaveRequestInformation';
		var objCallback = LeaveRequestInformation; 
        
        var leaveRequestApiURL = apiUrl + '/LeaveRequest';
        
         
        /**
         * Get the LeaveRequestInformation and the qualification Group
         * @memberof LeaveRequestFactory
         * @param {function} callback  an on success callback function
         * @param {function} errorCallback  an on error callback function
         */
        function getConfigurationDetails(callback,errorCallback) {
           return $http.get(leaveRequestApiURL, { 'Content-Type': 'application/json' })
                .then(function(responseData){
                    if(responseData && responseData.data && responseData.data.data && responseData.data.data.LeaveRequestInformation){
                           saveLeaveRequestInformation(responseData.data.data.LeaveRequestInformation);
                    }
                    callback(responseData);
                 })
                .catch(errorCallback);
        }
         
        function saveLeaveRequest(request,callback,errorCallback){
            var cleanRequest = angular.toJson(request);
            console.log(cleanRequest);
            return $http.post(leaveRequestApiURL,cleanRequest ,{ 'Content-Type': 'application/json' })
                .then(function(responseData){
                    if(responseData && responseData.data && responseData.data.data && responseData.data.data.LeaveRequestInformation){
                           saveLeaveRequestInformation(responseData.data.data.LeaveRequestInformation);
                    }
                    callback(responseData);
                 })
                .catch(errorCallback);
        }
        /**
         * Save the leave Request Information  Object in local storage
         * @memberof LeaveRequestFactory
         * @param {object} leaveRequestInformation  a leaveRequestInformation
         */
        function saveLeaveRequestInformation(leaveRequestInformation){
            GenericService.saveOne(leaveRequestInformation,objType,objCallback);
        }
       	
        /**
         * Save the leave Request Information  Object in local storage
         * @memberof LeaveRequestFactory     
         * @returns {object} leaveRequestInformation  
         */
        function getLeaveRequestInformation(){
           return GenericService.getOne(objType,objCallback);
        }

        /**
         * Fetch requested leave slots from Crew Planning Lab directly via API.
         * Returns current and next year slots regardless of submission period status.
         * Does NOT use localStorage. Requires internet connectivity.
         * Response shape mirrors GET /LeaveRequest: { QualificationGroup, LeaveRequestInformation, LeaveRequest }
         * @param {function} callback  on success callback
         * @param {function} errorCallback  on error callback
         */
        function getRequestedSlots(callback, errorCallback) {
            return $http.get(leaveRequestApiURL + '/RequestedSlots', { 'Content-Type': 'application/json' })
                .then(function (responseData) {
                    callback(responseData);
                })
                .catch(errorCallback);
        }


        return service;
    }


})();